import api from '@/api';

const resource = 'merenda/cardapio-turma';

export default {
  lancarTurmasPorCardapio( identificadorcardapioescola, turmas ) {
    return api.post( `${resource}`, {identificadorcardapioescola, turmas} );
  },

  listarTurmasPorCardapio( identificadorcardapioescola ) {
    return api.get( `${resource}`, { params: {identificadorcardapioescola} });
  },

  buscarCardapiosPorEscola(aaletivo, cdtipesc, cdescola) {
    return api.get( `${resource}/por-escola`, { params: {aaletivo, cdtipesc, cdescola } });
  },

  buscarturmasPorCardapio(identificadorcardapioescola) {
    return api.get( `${resource}/turmas-por-cardapio/${identificadorcardapioescola}`);
  },
};
